<template>
  <div class="receipt-view home">
    <Navbar></Navbar>
    <div id="scroll-element">
      <div>
        <mini-cart></mini-cart>
      </div>
      <receipt-orders></receipt-orders>
    </div>
  </div>
</template>

<script>
import Navbar from "../../../components/public/common/Navbar";
import MiniCart from "../../../components/public/cart/MiniCart";
import ReceiptOrders from "../../../components/public/receipt/ReceiptOrders";

export default {
  name: "receipt-view",
  components: {
    Navbar,
    MiniCart,
    ReceiptOrders
  },
  data() {
    return {
      open: false
    };
  }
};
</script>

<style lang="scss">
.receipt-view {
  padding-top: 0 !important;
}
</style>
